var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconTurkey = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.1 10.557-.771-1.286-.772-1.028-1.414-1.929 1.543.515s-.515-1.029-.9-1.672C18.4 4.514 17.886 4 17.114 4c-.771 0-1.543.514-1.543 1.286 0 .385.129.643.258 1.028.257.386 1.542 2.057 1.542 2.057.129.258.129.643-.128.772-.129.128-.514.128-.772.128-.642-.385-2.185-.385-2.7-.257-1.928.257-3.728 1.157-3.728 1.157L6.57 5.03A12.823 12.823 0 0 0 4 12.1c0 3.086 1.543 6.043 4.243 7.714.771-.385 2.186-1.285 2.186-1.285h2.828l.257 2.442c-.385 0-.514.386-.514.772h2.829c0-.386-.258-.643-.643-.772h-1.029L13.9 18.53h2.957c1.029 0 1.929-.258 2.7-.772 1.414-.9 2.314-2.571 2.443-4.371 0-1.029-.386-2.057-.9-2.829z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTurkey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-turkey.d36de5aa.svg";
export { ForwardRef as ReactComponent };